'use client';

import React from 'react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';
import { SessionTimeoutWarning } from './SessionTimeoutWarning';

interface SessionTimeoutWrapperProps {
  children: React.ReactNode;
}

export function SessionTimeoutWrapper({ children }: SessionTimeoutWrapperProps) {
  const { showWarning, timeRemaining, handleStayLoggedIn, handleLogout } = useSessionTimeout({
    timeoutMinutes: 24 * 60, // 24 hours timeout (1440 minutes)
    warningBeforeSeconds: 300, // Show warning 5 minutes before timeout
  });

  return (
    <>
      {children}
      <SessionTimeoutWarning
        isOpen={showWarning}
        timeRemaining={timeRemaining}
        onStayLoggedIn={handleStayLoggedIn}
        onLogout={handleLogout}
      />
    </>
  );
}

